export const LOCATOR_URL = 'https://gisportal.horrycounty.org/server/rest/services/Locators/County_Locator/GeocodeServer'
export const MIN_SCORE = 80